<template>
  <div class="grossing-sample-grid-page">
    <b-row class="search-block  mb-3 mt-1">
      <b-col
        xl="4"
        cols="6"
      >
        <searcher-module
          ref="searcherModule"
          name="grossingSearcher"
          :error-message="$tc('grossing.error.validIdentifier')"
          portion-search
          sample-search
          case-search
          @portionSearch="onPortionSearch($event)"
          @sampleSearch="onSampleSearch($event)"
          @studySearch="onStudySearch($event)"
        />
      </b-col>
      <b-col
        xl="8"
        cols="6"
        class="d-flex align-items-center justify-content-end"
      >
        <div>
          <b-button
            v-shortkey="['f10']"
            qa="grossing-grid-patients-button"
            class="btn__link px-3"
            @shortkey.prevent="openPatientModal(false, false)"
            @click="openPatientModal(false, false)"
          >
            <i
              class="far fa-users mr-2"
              aria-hidden="true"
            />{{ $tc('global.patients') }}
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!--Grossing Grid-->
    <div
      v-if="columnDefs"
      class="grid-container"
    >
      <GridHeader
        :gridtitle="selectedOption ? $tc(selectedOption.label) : ''"
        :gridsubtitle="msgSelectedRows"
        :qa="componentId"
      >
        <grid-display-options
          v-if="gridApi"
          :ui-component="gridUiComponent"
          @changedPageSize="changedPageSize($event)"
          @changedMode="changedMode($event)"
        />
        <div class="pl-1 pr-0 d-flex align-items-center">
          <button
            id="samplesCleanFilters"
            v-tooltip="$tc('global.cleanFilter')"
            v-shortkey="['ctrl', 'alt', 'f']"
            qa="grossing-grid-clean-button"
            class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
            type="button"
            @shortkey.prevent="cleanFilters"
            @click="cleanFilters"
          >
            <i
              class="far fa-filter"
              aria-hidden="true"
            />
          </button>
        </div>

        <vt-report-export-buttons
          source="grossing-grid"
          :export-report="exportReport"
        />

        <!-- TODO: Comment for future development -->
        <!--<div class="pl-1 pr-0 d-flex align-items-center">
                    <b-button qa="grossing-grid-shipments-button" class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
                              v-if="canCreateShipmentRequests()"
                              :disabled="!selectedRows.length"
                              @click="checkToSend()">
                        <i v-tooltip="$tc('shipments.actions.checkToSend')" class="far fa-box" aria-hidden="true"/>
                    </b-button>
                </div>-->
      </GridHeader>
      <vt-grid
        ref="vtGrid"
        :short-key="shortKey"
        qa="grossing-grid"
        class="grossing-sample-grid"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :component-code="uiComponent"
        :component-id="componentId"
        :use-detail-custom-config="true"
      />
    </div>
    <modal-wrapper ref="addFilterModal">
      <add-custom-filter-modal
        id="addFilterModal"
        @ok="onAddFilterOk"
      />
    </modal-wrapper>
    <modal-wrapper ref="grossingResponsibleModal">
      <grossing-responsible-modal
        route-is-grossing
        @reloadGrid="reloadRowData()"
      />
    </modal-wrapper>
    <print-component ref="printComponent" />
    <modal-wrapper ref="searchPatientModal">
      <search-patient-modal id-modal="searchPatientModal" />
    </modal-wrapper>
    <modal-wrapper ref="itemsForShippingModal">
      <items-for-shipping-modal
        :samples="samplesToSend"
        :lab-id="laboratoryIdLogged"
      />
    </modal-wrapper>
    <modal-wrapper ref="addFileModalWrapper">
      <add-file-modal
        id="addFileModal"
        ref="addFileModal"
        :attachment-entity-type="coreEntityCode"
        :entities-id-array="entitiesIdArray"
        @attachmentsAdded="reloadRowData()"
      />
    </modal-wrapper>
    <common-attachment-modal-tree
      v-if="selectedPatientForAttachmentTreeModal"
      ref="attachmentTreeModal"
      :patient="selectedPatientForAttachmentTreeModal"
      :laboratory-id="laboratoryIdLogged"
      @attachments-updated="reloadRowData()"
    />
    <modal-wrapper ref="incidentModalTreeWrapper">
      <common-incident-modal-tree
        @incident-added="reloadRowData()"
      />
    </modal-wrapper>
    <modal-wrapper ref="incidentFormModal">
      <incident-form-modal
        id="incidentFormModal"
        :core-entity="coreEntityCode"
        @incident-added="reloadRowData()"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import GridHeader from '@/components/GridHeader'
import VtGrid from '@/components/VtGrid/VtGrid'
import { grossingGridSampleColumnDefs } from '@/modules/grossingModule/views/grid/column-defs/grossing-grid-sample.column-defs'
import { grossingGridSamplePendingArchiveColumnDefs } from '@/modules/grossingModule/views/grid/column-defs/grossing-grid-sample-pending-archive.column-defs'
import { grossingGridSampleTakeOutFromArchiveColumnDefs } from '@/modules/grossingModule/views/grid/column-defs/grossing-grid-sample-take-out-from-archive.column-defs'
import { GrossingSampleDatasource } from '@/modules/grossingModule/views/grid/config/grossing-sample-datasource'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import SearcherModule from '@/components/SearcherModule'
import grossingSideBarStore from '@/modules/grossingModule/sideBar/grossingSideBarStore'
import AddCustomFilterModal from '@/components/customFilter/AddCustomFilterModal'
import customFilterResource from '@/api/resources/ui/CustomFilterResource'
import { isEmpty } from 'lodash'
import Encoder from '@/utils/encoder'
import grossingSampleService from '@/modules/grossingModule/services/grossingSampleService'
import sampleProcessingVirtualShelvesService from '@/modules/sampleProcessingModule/services/sampleProcessingVirtualShelvesService'
import sampleProcessingPortionService from '@/modules/sampleProcessingModule/services/sampleProcessingPortionService'
import GrossingResponsibleModal from '@/modules/grossingModule/modals/GrossingResponsibleModal'
import SearchPatientModal from '@/components/searcherPatientModal/SearchPatientModal'
import { SAMPLE_STATES } from '@/api/resources/entityState/sample-state'
import GridDisplayOptions from '@/components/GridDisplayOptions'
import { GROSSING_TASK } from '@/modules/grossingModule/sideBar/sideBarOptions'
import ItemsForShippingModal from '@/modules/shipments-module/old/views/components/ItemsForShippingModal'
import sampleProcessingCaseService from '@/modules/sampleProcessingModule/services/sampleProcessingCaseService'
import sampleProcessingSampleService from '@/modules/sampleProcessingModule/services/sampleProcessingSampleService'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'
import { ShipmentOperationGuardMixin } from '@/api/operations/mixins/guards/shipment-operation-guard.mixin'
import { GridExportMixin } from '@/mixins/grid-export.mixin'
import { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'
import CommonIncidentModalTree from '@/components/incidentsModal/CommonIncidentModalTree'
import IncidentFormModal from '@/components/incidentsModal/IncidentFormModal'
import CommonAttachmentModalTree from '@/components/attachments/CommonAttachmentModalTree'
import AddFileModal from '@/components/AddFileModal'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'
import { GridUtils } from '@/shared/util/grid-utils'

export default {
    name: 'GrossingSampleGrid',
    components: {
        GridHeader,
        VtGrid,
        SearcherModule,
        AddCustomFilterModal,
        GrossingResponsibleModal,
        SearchPatientModal,
        GridDisplayOptions,
        ItemsForShippingModal,
        CommonIncidentModalTree,
        IncidentFormModal,
        CommonAttachmentModalTree,
        AddFileModal
    },
    mixins: [
        SampleOperationGuardMixin,
        ShipmentOperationGuardMixin,
        IncidentOperationGuardMixin,
        GridExportMixin
    ],
    props: {
        initMode: { type: Object, default: () => ({ value: 'compact', icon: 'fal fa-align-justify' }) },
        initSortModel: { type: Array, default: () => [] },
        initPaginator: { type: Object, default: null },
        initTabId: { type: Number, default: 0 }
    },
    data() {
        return {
            gridUiComponent: 'uicomponent.grossing.samplegrid',
            samplesToSend: [],
            mode: this.initMode,
            virtualShelves: [],
            dataDetail: null,
            messageProcessModal: '',
            samId: null,
            showSidePanel: false,
            selectedGrossingSample: null,
            columnDefs: null,
            gridApi: null,
            columnApi: null,
            validationRegex: [],
            sideBarState: grossingSideBarStore.state,
            encoder: new Encoder(),
            selectedRows: [],
            shortKey: {
                keys: ['ctrl', 'enter'],
                callFn: this.openSampleView
            },
            entitiesIdArray: null,
            selectedPatientForAttachmentTreeModal: null
        }
    },
    computed: {
        coreEntityCode() {
            return COREENTITY_VALUES.SAMPLE.code
        },
        gridOptions() {
            return {
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged,
                paginationPageSize: 20,
                paginationAutoPageSize: false,
                sideBar: gridSideBarConfig,
                getContextMenuItems: this.getContextMenuItems,
                onRowDoubleClicked: this.onRowDoubleClicked,
                getRowHeight: () => this.rowHeight,
                onSortChanged: ({ api }) => api.deselectAll(),
                onFilterChanged: ({ api }) => api.deselectAll(),
                autoGroupColumnDef: {
                    headerName: 'Consoles', // custom header name for group
                    pinned: 'left', // force pinned left. Does not work in columnDef
                    cellRendererParams: {
                        suppressCount: true// remove number in Group Column
                    }
                }
            }
        },
        laboratoryIdLogged() {
            return this.$store.getters.labId
        },
        sideBar() {
            // changes when the sideBar is expanded or contracted
            return this.sideBarState.sideBar
        },
        rowHeight() {
            if (this.mode.value === 'compact') {
                return 25
            }
            return 40
        },
        displayedColumns() {
            return this.columnApi.getAllDisplayedColumns()
        },
        sortModel() {
            return this.gridApi.getSortModel()
        },
        regex() {
            return this.$store.getters.regex
        },
        msgSelectedRows() {
            if (this.selectedRows.length) {
                const choice = this.selectedRows.length > 1 ? 2 : 1
                return `${this.selectedRows.length} ${this.$tc('global.selectedElements', choice)}`
            }
            return ''
        },
        viewAllEnabled() {
            return !!this.sideBarState.config.viewAllEnabled
        },
        selectedOption() {
            return this.sideBarState.selectedOption
        },
        componentId() {
            return this.selectedOption?.id?.toString()
        },
        uiComponent() {
            if (this.selectedOption) {
                return this.selectedOption.uicomponent
            }
            return null
        }
    },
    async created() {
        const selectedOption = this.$route.params.sidebarOption || this.selectedOption?.id
        if (selectedOption) {
            const option = grossingSideBarStore.findOptionById(selectedOption)
            await grossingSideBarStore.setSelectedOption(option)
        } else {
            grossingSideBarStore.selectDefaultOption()
        }
        await this.getVirtualShelves()
        this.setGridColumns()
        await grossingSideBarStore.loadCustomOptions()
    },
    methods: {
        showInGlobalLocator(label) {
            this.$eventHub.$emit('show-in-global-locator', label)
        },
        showAddFileModal(params) {
            this.entitiesIdArray = [this.laboratoryIdLogged, params.caseStudy.casId, params.samId]
            this.$refs.addFileModalWrapper.show()
        },
        showAttachmentModal(params) {
            this.selectedPatientForAttachmentTreeModal = { patId: params.caseStudy.patientId }
            this.$nextTick(() => {
                this.$refs.attachmentTreeModal.showSample(params.samId)
            })
        },
        openIncidentFormModal(sample) {
            const entitiesIds = {
                casId: sample.caseStudy.casId,
                samId: sample.samId
            }
            this.$nextTick(() => {
                this.$refs.incidentFormModal.show([null, entitiesIds])
            })
        },
        onIncidentsClicked(sample) {
            let defaultOption = {
                coreEntity: this.coreEntityCode,
                casId: sample.caseStudy.casId,
                samId: sample.samId
            }
            const patientId = sample.caseStudy.patientId
            this.$refs.incidentModalTreeWrapper.show([defaultOption, patientId])
        },
        checkToSend(gridElement) {
            if (gridElement) {
                this.samplesToSend = gridElement
            } else {
                this.samplesToSend = this.selectedRows
            }
            this.$refs.itemsForShippingModal.show()
        },
        setDataSource(sidebarOption, keepCurrentFilterModel) {
            if (this.gridApi) {
                const filterModel = keepCurrentFilterModel ? this.gridApi.getFilterModel() : sidebarOption.filterModel
                this.setGridColumns(sidebarOption.task)
                this.applySideBarFilterModel(filterModel)

                this.gridApi.setServerSideDatasource(
                    new GrossingSampleDatasource(
                        this.laboratoryIdLogged,
                        sidebarOption.task.url,
                        this.viewAllEnabled))
            }
        },
        applySideBarFilterModel(filterModel) {
            if (this.gridApi) {
                if (filterModel) {
                    this.gridApi.setFilterModel(filterModel)
                } else {
                    this.gridApi.setFilterModel({})
                }
            }
        },
        setGridColumns(sidebarTask) {
            let newColumnDefs
            if (sidebarTask === GROSSING_TASK.TO_BE_ARCHIVED) {
                newColumnDefs = grossingGridSamplePendingArchiveColumnDefs()
            } else if (sidebarTask === GROSSING_TASK.TO_BE_UNARCHIVED_FOR_REGROSSING) {
                newColumnDefs = grossingGridSampleTakeOutFromArchiveColumnDefs()
            } else {
                newColumnDefs = grossingGridSampleColumnDefs()
            }
            if (JSON.stringify(newColumnDefs) !== JSON.stringify(this.columnDefs)) {
                this.columnDefs = newColumnDefs
            }
        },
        async onSideBarClickUpdateFilter(option) {
            if (isEmpty(this.gridApi.getFilterModel())) {
                this.saveNoFilter()
                return
            }
            const params = { filterModel: this.gridApi.getFilterModel(), task: this.selectedOption.task, uicomponent: this.selectedOption.uicomponent }
            const [err] = await this.toCall(grossingSideBarStore.updateCustomOption(option, params))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            await grossingSideBarStore.loadCustomOptions()
            this.showToastSuccessGlobal(this.$tc('global.filterUpdated'))
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        openSampleView() {
            if (this.selectedRows.length === 1) {
                grossingSideBarStore.setSelectedOption(null)

                const selection = this.selectedRows[0]
                this.$router.push({ name: 'grossingSampleView', params: { casId: selection.caseStudy.casId, samId: selection.samId } })
            }
        },
        openPatientModal(showCreateButton = false, showSelectButton = false) {
            this.$refs.searchPatientModal.show([showCreateButton, showSelectButton])
        },
        onGridReady(api) {
            this.gridApi = api.api
            this.columnApi = api.columnApi
            this.setDataSource(this.selectedOption)
        },
        reloadRowData() {
            this.reloadData()
            this.$emit('updateSummary')
        },
        reloadData() {
            if (this.gridApi && this.columnApi) {
                this.gridApi.deselectAll()

                // force synchronous event calling immediately
                const event = {
                    api: this.gridApi,
                    columnApi: this.columnApi,
                    type: 'selectionChanged'
                }
                this.onSelectionChanged(event)
                this.setDataSource(this.selectedOption)
            }
        },
        getRowData() {
            this.setDataSource(this.selectedOption)
            if (this.$refs.vtGrid) {
                this.$refs.vtGrid.loadCustomConfig()
            }
        },
        changedMode(selectedOption) {
            this.mode = selectedOption
            GridUtils.changeRowHeightGrid(this.gridApi, selectedOption.size)
        },
        changedPageSize(pageSize) {
            if (this.gridApi) {
                this.gridApi.paginationSetPageSize(pageSize)
            }
        },
        cleanFilters() {
            this.setDataSource(this.selectedOption)
        },
        isAnySamplePendingGrossing(samples) {
            return samples.some(sample =>
                [SAMPLE_STATES.REGISTERED.code, SAMPLE_STATES.REPROCESSING_REQUESTED.code].includes(sample.status.code))
        },
        getContextMenuItems(params) {
            if (params?.node) {
                const selectedRows = this.selectedRows === 0
                    ? [params.node.data]
                    : this.selectedRows
                const areAllSamplesPendingGrossing = selectedRows.every(sample =>
                    [SAMPLE_STATES.REGISTERED.code, SAMPLE_STATES.REPROCESSING_REQUESTED.code].includes(sample.status.code))
                return [
                    {
                        name: this.$tc('grossing.grid.changeShelf'),
                        subMenu: this.getVirtualShelfSubMenu(selectedRows),
                        cssClasses: this.$_canEditSample() && areAllSamplesPendingGrossing ? '' : ['not-show']
                    },
                    {
                        name: this.$tc('grossing.grid.changeResponsibles'),
                        action: () => this.$refs.grossingResponsibleModal.show([selectedRows]),
                        cssClasses: this.$_canEditSample() && this.isAnySamplePendingGrossing(selectedRows) ? '' : ['not-show']
                    },
                    // TODO: Comment for future development
                    /* {
                        name: this.$tc('shipments.actions.checkToSend'),
                        cssClasses: this.selectedRows.length || !this.canCreateShipmentRequests() ? ['not-show'] : '',
                        action: () => this.checkToSend([params.node.data])
                    }, */
                    {
                        name: this.$tc('registry.caseGrid.contextMenu.viewIncidents'),
                        action: () => this.onIncidentsClicked(params.node.data),
                        cssClasses: selectedRows.length > 1 ? ['not-show'] : ''
                    },
                    {
                        name: this.$tc('registry.caseGrid.contextMenu.registerIncident'),
                        action: () => this.openIncidentFormModal(params.node.data),
                        cssClasses: selectedRows.length === 1 && this.$_canCreateIncident() && this.$_canBeIncidentCreatedToSample(params.node.data) ? '' : ['not-show']
                    },
                    {
                        name: this.$tc('laboratory.grid.contextMenu.viewAttach'),
                        action: () => this.showAttachmentModal(params.node.data),
                        cssClasses: selectedRows.length > 1 ? ['not-show'] : ''
                    },
                    {
                        name: this.$tc('laboratory.grid.contextMenu.addAttach'),
                        action: () => this.showAddFileModal(params.node.data),
                        cssClasses: selectedRows.length > 1 || !this.$_canAttachDocumentToSample() || !this.$_canBeDocumentAttachedToSample(params.node.data) ? ['not-show'] : ''
                    },
                    {
                        name: this.$t('global.showInGlobalLocator'),
                        action: () => this.showInGlobalLocator(params.node.data.samLabel),
                        cssClasses: selectedRows.length > 1 ? ['not-show'] : ''
                    }
                ]
            }
            return []
        },
        exportReport(exportType) {
            const columns = this.$_getColumnsToExport(this.gridApi, this.columnApi)
            if (columns && this.gridApi) {
                return grossingSampleService.exportTo(
                    this.laboratoryIdLogged,
                    this.$tc(this.selectedOption.label),
                    this.encoder.parseBooleans(this.gridApi.getFilterModel()),
                    GridUtils.getSortValue(this.sortModel),
                    columns,
                    this.selectedRows.map(selectedRow => selectedRow.samId ?? selectedRow.id),
                    this.selectedOption.task.url,
                    this.viewAllEnabled,
                    exportType)
            }
            return null
        },
        onSideBarClickAddFilter() {
            this.$refs.addFilterModal.show()
        },
        async onAddFilterOk(option) {
            const params = { label: option.label, filterModel: this.gridApi.getFilterModel(), task: this.selectedOption.task, uicomponent: this.selectedOption.uicomponent }
            await customFilterResource.create(this.sideBarState.componentCode, params)
            await grossingSideBarStore.loadCustomOptions()
            this.showToastSuccessGlobal(this.$tc('global.filterAdded'))
        },
        onViewAllToggled() {
            this.reloadRowData()
        },
        async onShelfChange(data) {
            let saveData
            if (this.selectedRows.length) {
                saveData = this.selectedRows.map((row) => {
                    return {
                        laboratoryId: this.laboratoryIdLogged,
                        virtualShelfId: data.virtualShelfId,
                        caseId: row.caseStudy.casId,
                        sampleId: row.samId,
                        grossingTechControllerId: row.grossingTechController ? row.grossingTechController.id : null,
                        grossingTutorId: row.grossingTutor ? row.grossingTutor.id : null,
                        grossingCoordinatorId: row.grossingCoordinator ? row.grossingCoordinator.id : null,
                        grossingResponsibleId: row.grossingResponsible ? row.grossingResponsible.id : null,
                        originalConcurrencyUpdatedAt: row.originalConcurrencyUpdatedAt
                    }
                })
            } else {
                saveData = [data]
            }
            const [err] = await this.toCall(sampleProcessingSampleService.updateBatch(this.laboratoryIdLogged, saveData))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.setDataSource(this.selectedOption)
            this.gridApi.deselectAll()
            this.$emit('updateSummary')
        },
        getVirtualShelfSubMenu(selectedSamples) {
            this.virtualShelves.forEach(shelf => {
                shelf.action = () => selectedSamples.forEach(sample => this.onShelfChange({
                    laboratoryId: this.laboratoryIdLogged,
                    virtualShelfId: shelf.id,
                    caseId: sample.caseStudy.casId,
                    sampleId: sample.samId,
                    grossingTechControllerId: sample.grossingTechController ? sample.grossingTechController.id : null,
                    grossingTutorId: sample.grossingTutor ? sample.grossingTutor.id : null,
                    grossingCoordinatorId: sample.grossingCoordinator ? sample.grossingCoordinator.id : null,
                    grossingResponsibleId: sample.grossingResponsible ? sample.grossingResponsible.id : null,
                    originalConcurrencyUpdatedAt: sample.originalConcurrencyUpdatedAt
                }))
            })
            return this.virtualShelves
        },
        async getVirtualShelves() {
            // Not mapped because the response object match with ag-grid
            let [err, response] = await this.toCall(sampleProcessingVirtualShelvesService.getVirtualShelvesByLaboratoryId(this.laboratoryIdLogged))
            if (!err) {
                response.forEach((sub) => {
                    sub.action = () => this.onShelfChange()
                })
                this.virtualShelves = response
            }
        },
        onRowDoubleClicked({ data }) {
            grossingSideBarStore.setSelectedOption(null)
            this.$router.push({
                name: 'grossingSampleView',
                params: {
                    casId: data.caseId || data.caseStudy.casId,
                    samId: data.id || data.samId
                }
            })
        },

        async onPortionSearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    sampleProcessingPortionService.searchPortionByLabel(
                        this.laboratoryIdLogged,
                        searchInformation.search),
                    error => this.$_showErrorModal(
                        error.response.data.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this.$tc('component.searcher.error.noPortion')
                            : undefined))

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.PORTION,
                            entityValue: entity,
                            laboratoryId: entity.sample.caseStudy.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation.search, foundEntities)
                }

                this.$router.push({
                    name: 'grossingSampleView',
                    params: {
                        casId: entitySelected.sample.caseStudy.casId,
                        samId: entitySelected.sample.samId,
                        porId: entitySelected.porId
                    }
                })
            }
        },
        async onSampleSearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    sampleProcessingSampleService.searchSampleBySampleLabel(
                        this.laboratoryIdLogged,
                        searchInformation.search),
                    error => this.$_showErrorModal(
                        error.response.data.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this.$tc('component.searcher.error.noSample')
                            : undefined))

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.SAMPLE,
                            entityValue: entity,
                            laboratoryId: entity.caseStudy.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation.search, foundEntities)
                }

                await grossingSideBarStore.setSelectedOption(null)
                this.$router.push({
                    name: 'grossingSampleView',
                    params: {
                        casId: entitySelected.caseStudy.casId,
                        samId: entitySelected.samId
                    }
                })
            }
        },
        async onStudySearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    sampleProcessingCaseService.searchCaseByCasenumber(
                        this.laboratoryIdLogged,
                        searchInformation.search),
                    error => {
                        if (error.response.data.code === this.$apiExceptions.ENTITY_NOT_FOUND) {
                            this.$_showErrorModal(this.$tc('component.searcher.error.noCase'))
                        } else {
                            this.$_showErrorModalFromErrorResponse(error)
                        }
                    })

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IDENTIFIER_SCOPES.CASE,
                            entityValue: entity,
                            laboratoryId: entity.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation.search, foundEntities)
                }

                /**
                 * navigate to first sample whose laboratory is the same as the logged-in user,
                 * if not show first available sample
                 */
                const samplesCurrentLaboratory =
                    entitySelected.samples.filter(
                        sample => sample.currentLaboratory.labId === this.laboratoryIdLogged)
                const sample =
                    samplesCurrentLaboratory.length
                        ? samplesCurrentLaboratory[0]
                        : entitySelected.samples[0]

                await grossingSideBarStore.setSelectedOption(null)
                this.$router.push({
                    name: 'grossingSampleView',
                    params: {
                        casId: entitySelected.casId,
                        samId: sample.samId
                    }
                })
            }
        }
    }
}
</script>

<style>
    .grossing-sample-grid-page .grossing-sample-grid {
        height: 100%;
    }
</style>
